<template>
    <div ref="container" class="clamp-text">
        <span ref="content">{{ clampedText }}</span><!--
        --><span v-if="isClamped" class="ellipsis">…</span>
    </div>
</template>

<script>
export default {
    name: 'ATextClamp',
    props: {
        text: {
            type: String,
            default: '',
        },
        maxLines: {
            type: Number,
            default: 2,
        },
        // Add some margin of error for the maxHeight calculation.
        // Should fix the situation when the span's scrollHeight is lineHeight + 1
        jitterPx: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            clampedText: this.text,
            isClamped: false,
        };
    },
    watch: {
        text(value) {
            this.clampedText = value;
            this.isClamped = false;
            this.$nextTick(this.calculate);
        },
    },
    mounted() {
        this.calculate();
        window.addEventListener('resize', this.calculate);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.calculate);
    },
    methods: {
        async calculate() {
            const container = this.$refs.container;
            const content = this.$refs.content;
            // Force the ellipsis so the fit routine takes it into account
            this.isClamped = true;
            // Initially put all the text available
            content.textContent = this.text;
            // Allow to redraw
            await this.$nextTick();

            // Measure the max allowed height
            const maxHeight = parseFloat(getComputedStyle(container).lineHeight) * this.maxLines + this.jitterPx;

            if (container.scrollHeight <= maxHeight) {
                // Everything fits, no need to clamp
                this.clampedText = this.text;
                this.isClamped = false;
                return;
            }

            const words = this.text.split(' ');

            // If no words fit, we'll at least have the 1st word to show.
            // If this ever happens though, it must be solved on the content level.
            let bestFit = words[0];
            let currentAttempt = '';

            // Gradually find the best fit by adding words one by one.
            // It's technically faster to use binary search,
            // but the linear search is already fast enough and much simplier.
            for (let i = 1; i <= words.length; i++) {
                currentAttempt = words.slice(0, i).join(' ');
                content.textContent = currentAttempt;

                if (container.scrollHeight > maxHeight) {
                    break;
                } else {
                    bestFit = currentAttempt;
                }
            }

            // Set the final content
            this.clampedText = bestFit;
            content.textContent = bestFit;
            this.isClamped = bestFit !== this.text;
        },
    },
};
</script>

<style>
.clamp-text {
    overflow: hidden;
    word-break: normal;
    overflow-wrap: anywhere;
}

.ellipsis {
    padding-left: 4px;
}
</style>
